var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","aria-modal":'true'}},[_c('v-card-title',[_vm._v(_vm._s(_vm.titleValue))]),_c('v-card-text',[_vm._v(_vm._s(_vm.contentValue))]),_c('v-btn',{on:{"click":_vm.closeAlert}},[_vm._v("OK ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }